import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "none",
      d: "M0 0h24v24H0Z",
      "data-name": "Pfad 2015"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M19.875 6.27A2.225 2.225 0 0 1 21 8.218V15.5a2.225 2.225 0 0 1-1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1-2.184 0l-6.75-4.27A2.225 2.225 0 0 1 3 15.5V8.217A2.223 2.223 0 0 1 4.158 6.27l6.75-3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033Z",
      "data-name": "Pfad 2016"
    }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m15 11-3 3-3-3",
      "data-name": "Pfad 2022"
    }, null, -1)
  ])))
}
export default { render: render }